import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
} from "@mui/material";

import { set } from "lodash";

function TableDataCode({
  columnWidth,
  heading,
  columnValue,
  title,
  topHeading,
  topheader,
  formValues,
  setErrors,
  errorsindex,
  setFormValues,
  setRowIndex,
  errors,
  disabled,
}) {
  const [columnArray, setColumnArray] = useState([]);

  useEffect(() => {
    const columnLength = columnWidth.split(" ");
    setColumnArray(columnLength);
  }, [columnWidth]);

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const handleChangeRadio = ({ target: { name, value } }) => {
    setFormValues((prev) => {
      const keys = name.split("."); // Assuming `name` is a dot-separated string
      const updatedForm = { ...prev };

      let current = updatedForm;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value; // Update the specific field
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return updatedForm;
    });
  };

  useEffect(() => {
    let newErrors = {};

    columnValue.forEach((item, rowIndex) => {
      if (item.value) {
        heading.slice(1).forEach((headings) => {
          const name = `${headings.key}.${item.key}`;
          newErrors[name] = {
            rowIndex,
            message: "", // Initialize with empty error message
          };
        });
      }
    });

    // Preserve previous errors instead of overriding them

    if (setRowIndex) {
      setRowIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const handleChange = (e, index) => {
    const { name, value } = e.target;

    if (!/^\d*$/.test(value)) return; // Allow only numeric values

    setFormValues((prevState) => {
      if (!prevState) return {};
      const keys = name.split(".");
      const updatedData = structuredClone(prevState);

      let currentLevel = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }
      // Update value
      currentLevel[keys[keys.length - 1]] = value ? Number(value) : "";

      // Ensure `total`, `male`, and `female` exist before calculations
      const totalEmployees = currentLevel?.total || 0;

      let lastPreviousKeys = [];
      let tempData = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (tempData?.[keys[i]]) {
          if (keys.length >= 5) {
            // If 4 or more keys, store the second key and last-to-previous key
            lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
          }

          tempData = tempData[keys[i]]; // Move deeper
        } else {
          break;
        }
      }

      const totalMale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.totalEmployee?.male || 0;
      const totalFemale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.totalEmployee?.female ||
        0;
      const totalOverall =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.totalEmployee?.total || 0;

      const employeeMale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.employee?.male || 0;
      const employeeFemale =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.employee?.female || 0;
      const employeeOverall =
        updatedData?.[keys[0]]?.[keys[1]]?.[keys[2]]?.employee?.total || 0;

      // Calculate percentages
      if (
        updatedData[keys[0]] &&
        updatedData[keys[0]][keys[1]] &&
        updatedData[keys[0]][keys[1]][keys[2]]
      ) {
        updatedData[keys[0]][keys[1]][keys[2]].Percentage = {
          male:
            totalMale > 0 ? ((employeeMale / totalMale) * 100).toFixed(3) : "0",
          female:
            totalFemale > 0
              ? ((employeeFemale / totalFemale) * 100).toFixed(3)
              : "0",
          total:
            totalOverall > 0
              ? ((employeeOverall / totalOverall) * 100).toFixed(3)
              : "0",
        };
      }
      let newValue = keys[keys.length - 1] === "male" ? totalMale : totalFemale;
      let maxAllowedTotal =
        keys[keys.length - 1] === "male" ? employeeMale : employeeFemale;
      console.log(
        maxAllowedTotal,
        newValue,
        keys[keys.length - 1],
        "valuessssforChecking"
      );
      if (maxAllowedTotal > newValue) {
        if (errorsindex) {
          setErrors((prevErrors) => {
            let newErrors = { ...prevErrors };

            Object.keys(errorsindex).forEach((errorKey) => {
              const nestedKeys = errorKey.split(".");
              const lastKey = keys[keys.length - 1]; // ✅ Extract last key
              const mainKey = nestedKeys[0]; // ✅ Always the first key
              const subKey =
                keys.length > 3 ? `${keys[1]}.${keys[2]}` : keys[1];

              // ✅ Extract row index dynamically
              const rowIndex =
                errorsindex[
                  keys.length > 3
                    ? `${keys[0]}.${keys[1]}.${keys[2]}.${keys[3]}`
                    : `${keys[0]}.${keys[1]}.${keys[2]}`
                ]?.rowIndex || "-";

              // ✅ Only update if mainKey === nestedKeys[0]
              if (mainKey === keys[0]) {
                // ✅ Reset previous messages for this mainKey
                newErrors[mainKey] = [];

                newErrors[mainKey].push({
                  subkey: subKey,
                  fieldName: lastKey,
                  rowIndex: rowIndex, // ✅ Ensures only this row's error is displayed
                  message: "Exceeded the value required field", // ✅ Always set the latest message
                });

                // ✅ Restrict user input by resetting the field to its previous valid value
                console.warn("❌ Input exceeded the allowed limit!");
              }
            });

            return newErrors; // ✅ Correctly return updated errors
          });
          return prevState;
        }
      } else {
        setErrors([]);
      }

      const mainKey = keys.length > 3 ? `${keys[0]}.${keys[1]}` : keys[0];

      if (keys.length > 3) {
        const [firstKey, secondKey, thirdKey] = keys;
        if (
          updatedData[firstKey]?.[secondKey]?.[thirdKey] &&
          lastPreviousKeys[3].includes("total")
        ) {
          updatedData[firstKey][secondKey][thirdKey].total = calculateTotals(
            updatedData[firstKey][secondKey][thirdKey]
          );
        }
      } else {
        if (updatedData[mainKey] && lastPreviousKeys[0].includes("total")) {
          updatedData[mainKey] = calculateTotals(updatedData[mainKey]);
        }
      }

      return updatedData;
    });
  };

  const calculateTotals = (data) => {
    // let totals = { total: 0, male: 0, female: 0 };

    const traverse = (node) => {
      if (typeof node !== "object" || node === null) return;

      Object.entries(node).forEach(([key, value]) => {
        if (typeof value === "object" && value !== null) {
          // If object has male, female, and total, update totals
          if ("male" in value && "female" in value && "total" in value) {
            let male = Number(value.male) || 0;
            let female = Number(value.female) || 0;
            let calculatedTotal = male + female;

            // totals.male += male;
            // totals.female += female;
            // totals.total += calculatedTotal;

            // ✅ Update `total` dynamically if it's missing or incorrect
            value.total = calculatedTotal;
          }

          // Recursively traverse deeper
          traverse(value);
        }
      });
    };

    traverse(data);

    // return totals;
  };

  const calculatePercentages = (data) => {
    const totalEmployees = ["permanent", "other"].reduce(
      (acc, key) => {
        const category = data[key];
        acc.total += Number(category.total || 0);
        acc.male += Number(category.male || 0);
        acc.female += Number(category.female || 0);
        return acc;
      },
      { total: 0, male: 0, female: 0 }
    );

    return {
      total: totalEmployees.total,
      male: totalEmployees.male,
      female: totalEmployees.female,
    };
  };

  return (
    <Box sx={{ minWidth: 650 }}>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "Capitalize",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        {topheader}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        {topHeading}
      </Typography>
      <Typography
        sx={{ marginBottom: "20px", fontWeight: "bold", marginTop: "10px" }}
        variant="body1"
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer component={Paper} sx={{ maxWidth: "100%", borderRadius: "10px", overflow: "hidden"  }}>
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {columnValue.map((item, rowIndex) => {
            if (item.value) {
              const isTotalRow = item.value.includes("Total"); // Check if the row is a Total row

              return (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: columnWidth,
                    borderBottom: "1px solid #ddd",
                    justifyContent: "center",
                  }}
                >
                  {/* Render Typography for the row */}
                  <Typography
                    sx={{
                      borderRight: "1px solid #DBDBDB",
                      fontSize: "15px",
                      padding: "10px",
                    }}
                  >
                    {item.value}
                  </Typography>
                  {heading.length > 0 &&
                    heading.slice(1).map((headings, index) => {
                      const differentlyAbled = item.key
                        ?.toLowerCase()
                        .includes("differentlyabled");
                      const turnoverRate = item.key?.includes("turnoverRate");
                      const wellBeingMeasures =
                        item.key?.includes("wellBeingMeasures");
                      const wellBeingWorkers =
                        item.key?.includes("wellBeingWorkers");
                      const retirementBenefits =
                        item.key?.includes("retirementBenefits");
                      const returnAndRetentionParentalLeave =
                        item.key?.includes("returnAndRetentionParentalLeave");
                      const performanceAndCareerReviews = item.key?.includes(
                        "performanceAndCareerReviews"
                      );
                      const name = `${headings.key}.${item.key}`;

                      // Split the name into parts using '.' as a delimiter
                      const matchResult = name.split(".");

                      // Ensure the split result is valid
                      if (matchResult.length < 3) {
                        // console.error(`Invalid name format: ${name}`);
                        return null; // Skip this iteration if the name format is invalid
                      }

                      const [mainKey, subKey, fieldKey, field1Key, field2Key] =
                        matchResult;

                      // const isPercentage = headings.title.includes("%");
                      const isPercentage =
                        headings.key !== "employeesCovered" &&
                        headings.key !== "workersCovered" &&
                        headings.title.includes("%");
                      // const isTotal = headings.title.includes("Total" !=="Total Employees");
                      const isTotal =
                        /Total(?! Employees || ?! No. of Employees)/.test(
                          headings.title
                        );

                      return (
                        <>
                          {headings.type === "boolean" ? (
                            <RadioGroup
                              disabled={disabled}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "0px",
                                padding: "0px 5px",
                              }}
                              // defaultValue="Yes" // Set the default selected value
                              value={
                                (mainKey === "retirementBenefits" &&
                                  formValues?.[mainKey]?.[subKey]?.[fieldKey]
                                    ?.deductedDeposited) ||
                                ""
                              }
                              name={name}
                              onChange={(e) =>
                                handleChangeRadio({
                                  target: {
                                    name,
                                    value: e.target.value,
                                  },
                                })
                              }
                            >
                              {["Yes", "No", "N/A"].map((item, index) => (
                                <FormControlLabel
                                  key={index}
                                  value={item}
                                  control={<Radio disabled={disabled} />}
                                  label={item}
                                />
                              ))}
                            </RadioGroup>
                          ) : (
                            <TextField
                              key={index} // Adding a key for mapping
                              variant="standard"
                              disabled={(isPercentage || isTotal || isTotalRow)? true :disabled}
                              sx={{
                                backgroundColor:
                                  isPercentage || isTotal || isTotalRow
                                    ? "#EFEFEF"
                                    : "",
                                borderRight: "1px solid #DBDBDB",
                                padding: "8px 12px",
                                "& .MuiInputBase-root": {
                                  padding: 0, // Align with grid cells
                                },
                              }}
                              name={name}
                              type="text"
                              InputProps={{ disableUnderline: true }}
                              fullWidth
                              size="small"
                              value={
                                formValues?.[mainKey]?.[subKey]?.[fieldKey]?.[
                                  field1Key
                                ]?.[field2Key] ?? ""
                              }
                              placeholder={
                                isTotal
                                  ? "Total"
                                  : isPercentage
                                  ? "%"
                                  : "Enter Number"
                              }
                              onChange={
                                !isTotalRow
                                  ? (e) => handleChange(e, rowIndex)
                                  : undefined
                              }
                            />
                          )}
                        </>
                      );
                    })}
                </Box>
              );
            }
          })}
        </Box>
      </TableContainer>

      {Array.isArray(errors) && errors.length > 0
        ? Object.entries(
            errors?.reduce((acc, item) => {
              if (!acc[item.rowIndex]) {
                acc[item.rowIndex] = [];
              }
              acc[item.rowIndex].push(item.fieldName);
              return acc;
            }, {})
          ).map(([rowIndex, fields], idx) => (
            <Typography
              variant="body2"
              color="error"
              key={`error-${rowIndex}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "0px",
              }}
            >
              Row {rowIndex} Missing fields: - {fields.join(", ")}
              {/* Row {rowIndex}: {fields.join(", ")} */}
            </Typography>
          ))
        : null}
    </Box>
  );
}

export default TableDataCode;
